<template>
  <div class="scheduled">
    <div class="container scheduled__group">
      <div
        class="scheduled__infor-card"
        v-if="creditCard || isPublicInstitution"
      >
        <img src="./../assets/images/illustration-1.svg" alt="" />
        <h2 class="scheduled__title">
          Agendamento realizado!
        </h2>
        <p class="scheduled__subtitle">
          Em breve você receberá um e-mail com as instruções para realizar a
          consulta.
        </p>

        <div class="scheduled__button">
          <a
            href="#"
            class="button2"
            @click.prevent="$router.push({ name: 'Dashboard' })"
          >
            Ver minhas consultas
          </a>
        </div>
      </div>
      <div class="scheduled__infor-card" v-if="pix">
        <img src="./../assets/images/illustration-1.svg" alt="" />
        <h2 class="scheduled__title">
          Agendamento pendente de pagamento!
        </h2>
        <p class="scheduled__subtitle mb-4">
          Não se preocupe, o agendamento foi finalizado mas ainda falta a etapa
          do pagamento.
        </p>

        <Pix :pix-data="pixData" />

        <p class="scheduled__subtitle mt-4">
          Você consegue ver o status da sua consulta na sua listagem de
          consultas.
        </p>

        <div class="scheduled__button">
          <a
            href="#"
            class="button2"
            @click.prevent="$router.push({ name: 'Dashboard' })"
          >
            Ver minhas consultas
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pix from "./../components/Pix.vue";

export default {
  name: "Scheduled",
  components: {
    Pix
  },
  computed: {
    creditCard() {
      return this.$route.params.payment_method == "credit_card";
    },
    pix() {
      return this.$route.params.payment_method == "pix";
    },
    pixData() {
      if (this.$route.params.appointmentResponse.appointments_orders) {
        return this.$route.params.appointmentResponse.appointments_orders[0]
          .pix_data;
      } else {
        return this.$route.params.appointmentResponse.order.pix_data;
      }
    },
    isPublicInstitution() {
      return this.$route.params.isPublicInstitution;
    }
  }
};
</script>
